import InterfaceSpri from "../apiInterface/InterfaceSpri";
import { join, values, mapValues } from "lodash";
import ErrorAlert from "@/utility/ErrorAlert";

class DataSpri {
  async getDataSpri(reg) {
    let dt: object = {};
    await InterfaceSpri.getSpri(reg)
      .then(response => {
        // dt = response.data;
        dt = response.data;
      })
      .catch(e => {
        // console.log(e);
        dt = e.response
        ErrorAlert.showSnackAlert(e, "SPRI")
        dt = e;
      });
    return dt;
  }

  async saveDataSpri(
    register_id,
    tanggal,
    keluhan_utama,
    riwayat_penyakit,
    pemeriksaan_fisik,
    pemeriksaan_penunjang,
    diagnosis,
    terapi,
    dokter_id,
    author_id,
    unit_id
  ) {
    let dt: object = {};
    await InterfaceSpri.saveSpri(
      register_id,
      tanggal,
      keluhan_utama,
      riwayat_penyakit,
      pemeriksaan_fisik,
      pemeriksaan_penunjang,
      diagnosis,
      terapi,
      dokter_id,
      author_id,
      unit_id
    )
      .then(response => {
        dt = response.data;
      })
      .catch(e => {
        // console.log(e);
        // console.log("respon", e.response);
        dt = e.response;
        ErrorAlert.showErrorAlert(e)
        // let message = "";
        // if (dt['status'] == 422) {
        //   message = join(
        //     values(
        //       mapValues(e.response.data.errors, function (val) {
        //         return join(val, "; ");
        //       })
        //     ),
        //     "; "
        //   );
        //   dt = { status: 0, err: "ERR 422 : " + e.response.data.message + " (" + message + ")" }
        //   // dt = { status: 0, err: "ERR 422 : " + e.response.data.message }
        // } else {
        //   dt = {
        //     data: dt,
        //     status: dt["status"],
        //     err: "ERR " + e.response.status + " : " + e.response.data.message
        //   };
        //   // dt = e.response
        // }
      });
    return dt;
  }
  async editDataSpri(
    id,
    register_id,
    tanggal,
    keluhan_utama,
    riwayat_penyakit,
    pemeriksaan_fisik,
    pemeriksaan_penunjang,
    diagnosis,
    terapi,
    dokter_id,
    author_id,
    unit_id
  ) {
    let dt: object = {};
    await InterfaceSpri.editSpri(
      id,
      register_id,
      tanggal,
      keluhan_utama,
      riwayat_penyakit,
      pemeriksaan_fisik,
      pemeriksaan_penunjang,
      diagnosis,
      terapi,
      dokter_id,
      author_id,
      unit_id
    )
      .then(response => {
        dt = response.data;
      })
      .catch(e => {
        // console.log("respon", e.response);
        dt = e.response;
        ErrorAlert.showErrorAlert(e)
        // let message = "";
        // if (dt['status'] == 422) {
        //   message = join(
        //     values(
        //       mapValues(e.response.data.errors, function (val) {
        //         return join(val, "; ");
        //       })
        //     ),
        //     "; "
        //   );
        //   dt = { status: 0, err: "ERR 422 : " + e.response.data.message + " (" + message + ")" }
        //   // dt = { status: 0, err: "ERR 422 : " + e.response.data.message }
        // } else {
        //   dt = {
        //     data: dt,
        //     status: dt["status"],
        //     err: "ERR " + e.response.status + " : " + e.response.data.message
        //   };
        //   // dt = e.response
        // }
      });
    return dt;
  }

  async saveDataTtdSpri(idSpri, user_id, password) {
    let dt: object = {}
    await InterfaceSpri.saveTtdSpri(idSpri, user_id, password).then((response) => {
      dt = response
    })
      .catch((e) => {
        // console.log('respon', e.response);
        dt = e.response
        // ErrorAlert.showErrorAlert(e)
        // let message = "";
        // if (dt['status'] == 422) {
        //   message = join(
        //     values(
        //       mapValues(e.response.data.errors, function (val) {
        //         return join(val, "; ");
        //       })
        //     ),
        //     "; "
        //   );
        //   dt = { status: 0, err: "ERR 422 : " + e.response.data.message + " (" + message + ")" }
        //   // dt = { status: 0, err: "ERR 422 : " + e.response.data.message }
        // } else {
        //   dt = { data: dt, status: dt['status'], err: "ERR " + e.response.status + " : " + e.response.data.message }
        //   // dt = e.response

        // }
      });
    return dt
  }
}

export default new DataSpri();
